import { createContext, useContext, useState } from 'react';

export const PAYMENT_SYSTEM_TYPES = {
  STRIPE: 'stripe',
  FORWARD: 'forward',
  ADYEN: 'adyen',
};

const initialPaymentSystemData = {
  paymentSystem: null,
  setPaymentSystem: () => {},
};

export const PaymentSystemContext = createContext(initialPaymentSystemData);

export const PaymentSystemProvider = ({ children }) => {
  const [paymentSystem, setPaymentSystem] = useState(initialPaymentSystemData.paymentSystem);

  return (
    <PaymentSystemContext.Provider value={{ paymentSystem, setPaymentSystem }}>
      {children}
    </PaymentSystemContext.Provider>
  );
};

export const usePaymentSystem = () => {
  return useContext(PaymentSystemContext);
};